import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CardActions, Button, TextField, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CircularProgress from '@mui/material/CircularProgress';

import Login from './Login';

import { forgotPassword } from '../../services/api';

const useStyles = makeStyles((theme) => ({
	icon: {
		marginRight: theme.spacing(1)
	},
	form: {
		padding: '0 8px 8px 8px'
	}
}));

const ForgotPasswordPage = () => {
	const [login, setLogin] = useState('');
	const [message, setMessage] = useState('');
	const [error, setError] = useState('');
	const [loading, setLoading] = useState(false);
	const classes = useStyles();
	const translate = useTranslate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setLoading(true);
		const response = await forgotPassword({ login });
		setLoading(false);
		if (response.success) {
			setMessage(translate('An email has been sent'));
		}
		else {
			setError(response.message);
		}
	};

	return (
		<Login>
			{message ? (
				<Typography align="center">{message}</Typography>
			) : (
					<form onSubmit={handleSubmit}>
						<div className={classes.form}>
							<TextField label="Email" type="text" name="login" value={login} onChange={(e) => setLogin(e.target.value)} helperText={error} error={!!error} size="small" fullWidth />
						</div>
						<CardActions>
							<Button
								variant="contained"
								type="submit"
								color="primary"
								disabled={loading}
								fullWidth
							>
								{loading && (
									<CircularProgress
										className={classes.icon}
										size={18}
										thickness={2}
									/>
								)}
								{translate('Forgot password')}
							</Button>
						</CardActions>
					</form>
				)}
		</Login>
	);
};

export default ForgotPasswordPage;
